import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container } from '../shim/reactstrap';
import { NavMenu } from './NavMenu';
import { Footer } from './Footer';

// Layout skips its chrome when the active route is an `/admin/*` page,
// because those pages render their own navbar / footer through the admin
// portal so the chrome can sit at the edges of the viewport (no centred
// container in between). Non-admin routes still get the navbar +
// centred container + footer.
export const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location && location.pathname && location.pathname.startsWith('/admin');
  // Admin pages render their own chrome (navbar, footer, admin-shell)
  // through a portal — the default Layout contributes nothing visible
  // for those routes so we don't end up with duplicate navbar/footer.
  // Children still mount, because the Admin component portals them away.
  if (isAdmin) {
    return <>{children}</>;
  }
  return (
    <div>
      <NavMenu />
      <Container>
        {children}
      </Container>
      <Footer />
    </div>
  );
};

Layout.displayName = 'Layout';
